export function encodeCellRange(cellRange) {
    return `${encodeCellAddress(cellRange.start.col, cellRange.start.row)}:${encodeCellAddress(cellRange.end.col, cellRange.end.row)}`;
}

export function encodeCellAddress(col, row) {
    let s = "";
    for (let column = col + 1; column > 0; column = Math.floor((column - 1) / 26)) s = String.fromCharCode((column - 1) % 26 + 65) + s;
    return s + (row + 1);
}
//# sourceMappingURL=encode.js.map
